var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"match-title"},[_c('i',{staticClass:"fa fa-circle",on:{"click":function($event){return _vm.$emit('check-code')}}}),_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }